var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Event, Property } from '@syncfusion/ej2-base';
/**
 * Defines the ribbon button item.
 */
export class RibbonButtonSettings extends ChildProperty {
    /**
     * @param {Object} prop - Gets the property of button.
     * @param {boolean} muteOnChange - Gets the boolean value of muteOnChange.
     * @returns {void}
     * @private
     */
    setProperties(prop, muteOnChange) {
        super.setProperties(prop, muteOnChange);
    }
}
__decorate([
    Property('')
], RibbonButtonSettings.prototype, "content", void 0);
__decorate([
    Property('')
], RibbonButtonSettings.prototype, "cssClass", void 0);
__decorate([
    Property('')
], RibbonButtonSettings.prototype, "iconCss", void 0);
__decorate([
    Property(false)
], RibbonButtonSettings.prototype, "isToggle", void 0);
__decorate([
    Property(false)
], RibbonButtonSettings.prototype, "isPrimary", void 0);
__decorate([
    Property({})
], RibbonButtonSettings.prototype, "htmlAttributes", void 0);
__decorate([
    Event()
], RibbonButtonSettings.prototype, "created", void 0);
__decorate([
    Event()
], RibbonButtonSettings.prototype, "clicked", void 0);
